import { isLanguage, Language } from 'hevy-shared/translations';

export const NEW_LANGUAGES = ['ar', 'ca', 'hi', 'pl'];
export const detectBrowserLanguage = (): Language | undefined => {
  const browserLanguages = navigator.languages;

  for (const lang of browserLanguages) {
    const [languageCode, regionCode] = lang.split('-');

    /** Just 'zh', isn't a supported language so we check if it is 'zh_CN' or 'zh_TW' */
    switch (languageCode) {
      case 'zh':
        const zhCode = `${languageCode}_${regionCode}`;

        if (isLanguage(zhCode)) {
          return zhCode;
        } else if (lang === 'zh-HK') {
          // Taiwan and Hong Kong both use Traditional characters
          return 'zh_TW';
        } else {
          /** Chrome lets you add a Chinese language (Chinese - 中文) that just has the language code
           * 'zh'and no region code. That one is Simplified Chinese
           */
          return 'zh_CN';
        }

      case 'pt':
        const ptCode = regionCode ? `${languageCode}_${regionCode}` : languageCode;

        if (isLanguage(ptCode)) {
          return ptCode;
        } else {
          return 'pt_BR';
        }
      default:
        if (isLanguage(languageCode) && !NEW_LANGUAGES.includes(languageCode)) {
          return languageCode;
        } else return undefined;
    }
  }
};
